@if (items.length) {
  <div class="preview-legend-block">
    @if (label) {
      <div class="preview-label">{{ label | translate }}</div>
    }
    <div class="preview-legend">
      @for (item of items; track trackByIndex($index)) {
        <div class="preview-legend-item">
          <div class="preview-legend-dot" [style.background]="item.color"></div>
          <div class="preview-legend-text">
            <span class="preview-legend-name">{{ item.name }}</span>
            @if (item.range) {
              <span class="preview-legend-range">{{ item.range }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
